var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
export var ChatMenuPopover = (function () {
    function ChatMenuPopover(viewCtrl) {
        this.viewCtrl = viewCtrl;
        this.showNeighborhoodLink = viewCtrl.data.showNeighborhoodLink;
    }
    ChatMenuPopover.prototype.sendNeighborhood = function () {
        this.viewCtrl.dismiss(ChatMenuAction.Neighborhood);
    };
    ChatMenuPopover.prototype.sendFacebookAdd = function () {
        this.viewCtrl.dismiss(ChatMenuAction.Facebook);
    };
    ChatMenuPopover = __decorate([
        Component({
            template: "\n    <ion-list class=\"menu-popover\">\n      <ion-list-header>Send a link...</ion-list-header>\n      <button ion-item (click)=\"sendFacebookAdd()\">Add me on Facebook</button>\n      <button *ngIf=\"showNeighborhoodLink\" ion-item (click)=\"sendNeighborhood()\">Neighborhood details</button>\n    </ion-list>\n    "
        }), 
        __metadata('design:paramtypes', [ViewController])
    ], ChatMenuPopover);
    return ChatMenuPopover;
}());
export var ChatMenuAction;
(function (ChatMenuAction) {
    ChatMenuAction[ChatMenuAction["Facebook"] = 0] = "Facebook";
    ChatMenuAction[ChatMenuAction["Neighborhood"] = 1] = "Neighborhood";
})(ChatMenuAction || (ChatMenuAction = {}));
